"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _componentLibrary = require("@sunrun/component-library");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StorageProfile = function StorageProfile(_ref) {
  var storageProfile = _ref.storageProfile;
  var storageMode = storageProfile.storageMode,
      storageProfileDetails = storageProfile.storageProfileDetails;

  var getProfile = function getProfile() {
    switch (storageMode) {
      case 'BACKUP_ONLY':
        return 'Backup Only';

      case 'DEFINED_PROFILE':
        return storageProfileDetails && storageProfileDetails.name || 'No Profile';

      case 'DISABLE_STOREDGE':
        return 'Disable Storedge';

      case 'MAXIMIZE_SELF_CONSUMPTION':
        return 'Maximize Self Consumption';

      case 'NO_PROFILE':
        return 'No Profile';

      default:
        return 'No Profile';
    }
  };

  if (!storageMode) return null;
  return /*#__PURE__*/_react["default"].createElement(_componentLibrary.Link, {
    target: "_blank",
    href: "https://docs.google.com/spreadsheets/d/1TZfCj8m0hnSBVbJIiFzhqw5sDelu2y-Yso52ifwg6io/edit#gid=1709744959"
  }, getProfile());
};

StorageProfile.propTypes = {
  storageProfile: _propTypes["default"].shape({
    storageMode: _propTypes["default"].string,
    storageProfileDetails: _propTypes["default"].shape({
      name: _propTypes["default"].string
    })
  }).isRequired
};
var _default = StorageProfile;
exports["default"] = _default;